module.exports = __webpack_public_path__ + "static/img/icon-step3.2eb9089f.png";